import React from 'react';

import styled from 'styled-components';

import { JiraLogoSrc, SalesforceSrc, DarwinBoxLogoSrc } from 'constants/icons';

const PluginImage = ({ icon = false, type = 'JIRA' }) => {
  const altText = type.toProperCase();
  let src = '';
  switch (type) {
    case 'JIRA':
      src = JiraLogoSrc;
      break;
    case 'SALESFORCE':
      src = SalesforceSrc;
      break;
    case 'DARWINBOX':
      src = DarwinBoxLogoSrc;
      break;
    default:
      break;
  }

  return <Image icon={icon} src={src} alt={altText} />;
};

const Image = styled.img`
  width: 4rem;
  ${({ icon }) =>
    icon &&
    `
    width: 1rem;
    vertical-align: text-bottom;
    margin-right: 0.5rem;
  `};
`;

export default PluginImage;
